<template>
  <div class="borda">
    <v-row align="center" class="pt-6">
      <v-col cols="12" md="4" class="py-1">
        <div>
          Parâmetro:
        </div>
      </v-col>
      <v-col cols="12" md="6" class="py-1">
        <input-cadu :onlyUpperCase="false" disabled :value="parametro" />
      </v-col>
    </v-row>

    <ValidationObserver ref="observer">
      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Nome Certificação/Selo:</div>
        </v-col>

        <v-col cols="12" md="4" class="py-1">
          <validation-provider name="area" mode="eager" rules="required" v-slot="{ errors }">
            <autocomplete-cadu
              :errorMessage="errors[0]"
              :items="listaTipoSelo.map((el) => el.nome)"
              v-model="seloSelecionado.nome"
              @index="indexUnimed"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Tooltip:</div>
        </v-col>

        <v-col cols="12" md="4" class="py-1">
          <validation-provider name="selo" mode="eager" rules="required|max:150" v-slot="{ errors }">
            <input-cadu :disabled="!seloSelecionado.id" :errorMessage="errors[0]" v-model="descricao" max="150" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Upload Imagem:</div>
        </v-col>

        <v-col cols="12" md="4" class="py-1">
          <validation-provider name="nomeArquivo" mode="eager" rules="required" v-slot="{ errors }">
            <input-cadu :onlyUpperCase="false" :errorMessage="errors[0]" disabled :value="nomeArquivo" />
          </validation-provider>
        </v-col>

        <v-col cols="auto" class="pl-0" v-if="seloSelecionado.id">
          <div class="drag-doc-area">
            <input
              type="file"
              @input="filesChange($event)"
              accept=".jpg, .jpeg, .png"
              class="input-file"
              :value="fileInput"
            />
            <a :style="colorProcurar"> procurar </a>
          </div>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Ordem:</div>
        </v-col>

        <v-col cols="12" md="2" class="py-1">
          <validation-provider name="ordem" mode="eager" rules="max:150" v-slot="{ errors }">
            <input-cadu
              :disabled="!seloSelecionado.id"
              :errorMessage="errors[0]"
              v-model="ordem"
              onlyNumber
              max="150"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </ValidationObserver>

    <v-row align="center">
      <v-col cols="12" md="4" class="py-1"> <div>Status:</div> </v-col>
      <v-col cols="1" class="pr-0"> {{ status ? 'Ativa' : 'Inativa' }} </v-col>

      <v-col cols="auto" class="py-1">
        <switch-cadu v-model="status" :disabled="!seloSelecionado.id" />
      </v-col>
    </v-row>

    <v-row align="center">
      <v-col cols="12" md="4" class="py-1"> <div>Bloquear Inserção/Edição:</div> </v-col>
      <v-col cols="2" class="pr-0"> {{ bloqueado ? 'Bloqueado' : 'Liberado' }} </v-col>

      <v-col cols="auto" class="py-1">
        <switch-cadu v-model="bloqueado" :disabled="!seloSelecionado.id" />
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-row justify="start">
        <v-col cols="auto" class="ml-4">
          <a style="color: #1492e6;" @click="showModalSelo = true"> + adicionar Nome Certificações/Selo </a>
        </v-col>
      </v-row>

      <v-col cols="auto" class="py-1">
        <button-cadu @click="salvarParametro">
          SALVAR
        </button-cadu>
      </v-col>
    </v-row>

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="showError" :errObj="errObj" />

    <SucessoModal
      :genericMessage="'Parâmetro atualizado com sucesso'"
      :showSucess="showSucess"
      @close="showSucess = false"
    />

    <SeloModal @att="atualizarModal" v-model="showModalSelo" />
  </div>
</template>

<script>
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'
import ErrorMixin from '@/Mixins/ErrorMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SeloModal from './Shared/SeloModal'

export default {
  mixins: [ErrorMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    SeloModal
  },
  data() {
    return {
      parametro: 'Certificações/Selo',
      listaTipoSelo: [],
      seloSelecionado: {
        nome: '',
        id: ''
      },
      status: false,
      bloqueado: false,
      fileInput: '',
      formData: new FormData(),
      ordem: '',
      descricao: '',
      parametrosGerais: '',
      nomeArquivo: '',
      showSucess: false,
      loadingOverlay: false,
      arquivo: '',
      showModalSelo: false,
      colorProcurar: {
        color: '#1492E6'
      }
    }
  },
  async created() {
    this.parametrosGerais = new ParametrosGerais(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
    await this.loadingFunc(this.getListaSelo())
  },
  methods: {
    async atualizarModal(input) {
      await this.loadingFunc(this.getListaSelo())
      await this.$nextTick
      this.seloSelecionado.nome = input.toUpperCase()
    },
    indexUnimed(index) {
      this.seloSelecionado.id = index !== null && index > -1 ? this.listaTipoSelo[index].id : ''
      if (this.seloSelecionado.id) {
        this.loadingFunc(this.getTipoSelo(this.seloSelecionado.id))
      } else {
        this.descricao = ''
        this.nomeArquivo = ''
        this.ordem = ''
      }
    },
    filesChange(e) {
      const file = e.target.files[0]
      this.formData.set('arquivo', file)
      this.nomeArquivo = file.name
    },
    async loadingFunc(...func) {
      this.loadingOverlay = true
      await Promise.all(func).finally(() => {
        this.loadingOverlay = false
      })
    },
    async promiseGeneric(className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    async getListaSelo() {
      const res = await this.promiseGeneric(this.parametrosGerais, 'getAllTipoSelo')
      this.listaTipoSelo = res.data
    },
    async getTipoSelo(id) {
      let response = await this.promiseGeneric(this.parametrosGerais, 'getTipoSelo', id)
      response = response.data

      const arquivo = response.arquivo

      if (!this.formData.has('arquivo')) {
        this.formData.append('arquivo', new File([''], null))
      }
      this.descricao = response.descricao
      this.nomeArquivo = arquivo.nome
      this.status = response.ativo
      this.bloqueado = response.bloqueado
      this.ordem = response.ordem
    },
    async salvarParametro() {
      if (this.showModalSelo) this.colorProcurar.color = this.nomeArquivo ? '#1492E6' : '#ED1651'

      const valid = await this.$refs.observer.validate()

      if (!valid) return

      await this.loadingFunc(
        this.promiseGeneric(
          this.parametrosGerais,
          'putParametroSelo',
          this.formData,
          this.status,
          this.bloqueado,
          this.descricao,
          this.seloSelecionado.id,
          this.ordem
        )
      )
      this.showSucess = true
    }
  }
}
</script>

<style lang="sass" scoped>
.borda
    border: 1px solid #00995d
    border-radius: 10px
    padding: 10px

.drag-doc-area
  border-radius: 22px
  position: relative
  width: fit-content
  height: fit-content
  background: none

.input-file
  opacity: 0
  position: absolute
  top: 0
  height: 100%
  width: 100%
</style>
